<template>
  <v-dialog :value="showModal" @input="$emit('close')" max-width="600px">
    <v-card class="modal-default-card">
      <v-card-title class="modal-default-header">
        <span class="modal-default-title">{{ title.toUpperCase() }}</span>
        <v-spacer></v-spacer>
        <v-btn icon @click="$emit('close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="modal-default-body">
        <ValidationObserver ref="observer">
          <v-row no-gutters>
            <v-col cols="12">
              <textarea-cadu
                v-model="internalObservation"
                :disabled="!editable"
                title=""
                :colorText="$vuetify.theme.themes.light.fontColor1"
                :max="'1000'"
                :errorMessage="charCountError"
                rows="5"
                no-resize
                class="textarea-modal-fix"
              />
              <div class="char-count-text">
                {{ internalObservation.length }} / 1000
              </div>
            </v-col>
          </v-row>
        </ValidationObserver>
      </v-card-text>

      <v-card-actions class="modal-default-footer">
        <v-spacer></v-spacer>
        <template v-if="editable">
          <button-cadu text="CANCELAR" style="padding: 10px;" @click="cancelEdit" :outline="true" />
          <button-cadu
            text="SALVAR"
            @click="saveObservation"
            :backColor="$vuetify.theme.themes.light.primary1"
          />
        </template>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { ValidationObserver } from 'vee-validate';
import ButtonCadu from '@/components/Shared/Buttons/ButtonCadu.vue';

export default {
  components: {
    ValidationObserver,
    ButtonCadu,
  },
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    observation: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: 'Observação',
    },
    editable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      internalObservation: '',
      initialObservation: '',
    };
  },
  computed: {
    charCountError() {
      if (this.internalObservation.length > 1000) {
        return 'Limite de 1000 caracteres excedido.';
      }
      return '';
    },
  },
  watch: {
    showModal(newVal) {
      if (newVal) {
        this.internalObservation = this.observation;
        this.initialObservation = this.observation;
        this.$nextTick(() => {
          if (this.$refs.observer) {
            this.$refs.observer.validate();
          }
        });
      }
    },
    observation: {
      immediate: true,
      handler(newVal) {
        if (this.showModal) {
          this.internalObservation = newVal;
          this.initialObservation = newVal;
        } else {
          this.internalObservation = newVal;
          this.initialObservation = newVal;
        }
      },
    },
  },
  methods: {
    async saveObservation() {
      let isValid = true;
      if (this.$refs.observer) {
        isValid = await this.$refs.observer.validate();
      }
      if (isValid && !this.charCountError) {
        this.$emit('save', this.internalObservation);
      }
    },
    cancelEdit() {
      if (this.editable && this.internalObservation !== this.initialObservation) {
        if (confirm('Você fez alterações. Deseja descartá-las?')) {
          this.$emit('close');
        }
      } else {
        this.$emit('close');
      }
    },
  },
};
</script>

<style scoped lang="scss">

.modal-default-card {
  border-radius: 8px !important;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1) !important;
  overflow: hidden;
}

.modal-default-header {
  background-color: #f5f5f5;
  padding: 16px 24px;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.modal-default-title {
  font-size: 1.25rem;
  font-weight: 500;
  color: #00995d !important;
  font-family: 'Roboto', sans-serif !important;
}

.modal-default-body {
  padding: 24px !important;
}

.custom-input-label {
  font-size: 0.875rem;
  color: rgba(0, 0, 0, 0.6);
  display: block;
  margin-bottom: 4px;
  padding-left: 12px;
}

.textarea-modal-fix {
  margin-top: 0px !important;
  padding-top: 0px !important;
}

.textarea-modal-fix :deep(textarea) {
  padding-left: 12px !important;
  padding-right: 12px !important;
  padding-top: 12px !important;
  padding-bottom: 12px !important;
  border: 1px solid rgba(0, 0, 0, 0.38) !important;
  border-radius: 4px !important;
}

.textarea-modal-fix.v-input--is-focused :deep(textarea) {
  border-color: var(--v-primary1-base) !important; 
  border-width: 2px !important;
}

.textarea-modal-fix :deep(.v-input__control .v-input__slot) {
  box-shadow: none !important;
}
.textarea-modal-fix :deep(.v-input__control .v-input__slot::before),
.textarea-modal-fix :deep(.v-input__control .v-input__slot::after) {
  display: none !important;
}

.char-count-text {
  text-align: right;
  font-size: 0.75rem;
  color: rgba(0, 0, 0, 0.6);
  margin-top: 4px;
}

.modal-default-footer {
  padding: 16px 24px !important;
  background-color: #f5f5f5;
  border-top: 1px solid #e0e0e0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
</style>